import React from "react";
export default function About() {
  return (
    <>
      <br />
      <br />

      {/* 1 section */}
      
      <div className="Story-heading-wrapper">
        <div className="Story-heading" data-aos="fade-up">
          <h1 style={{marginTop:"-50px"}}>
           About-Us
          </h1>
        </div>
        <div className="story-content-wrapper">
          <div className="Story">
            <div className="story-inside" data-aos="fade-up">
              <h1>Our Story</h1>
              <p>
                Inventore aliquam beatae at et id alias. Ipsa dolores amet
                <br /> consequuntur minima quia maxime autem. Quidem id sed{" "}
                <br /> ratione. Tenetur provident autem in reiciendis rerum at
                dolor.
                <br />
                Aliquam consectetur laudantium temporibus dicta minus
                <br /> dolor.
              </p>
              <div className="text-list">
                <p>Ullamco laboris nisi ut aliquip ex ea commo</p>
                <p>Duis aute irure dolor in reprehenderit in</p>
                <p>Ullamco laboris nisi ut aliquip ex eain</p>
              </div>
              <p>
                Vitae autem velit excepturi fugit. Animi ad non.
                <br /> Eligendi et non nesciunt suscipit repellendus <br />{" "}
                porro in quo eveniet. Molestias in maxime doloremque.
              </p>
            </div>
          </div>
          <div className="story-img">
            <img
              src="https://thumbs.dreamstime.com/b/group-human-resources-department-manager-reading-resume-document-employee-candidate-together-231586176.jpg"
              alt="story"
               data-aos="fade-down" data-aos-duration="1000"
            />
          </div>
        </div>
      </div>
      
      {/* 2 section */}

      <div className="our-team" style={{marginTop:"20px"}}>
        <div className="team-heading" data-aos="fade-up">
          <h1 style={{marginTop:"-5px"}}>OUR TEAM</h1>
        </div>
        <p data-aos="fade-up">
          Necessitatibus eius consequatur ex aliquid fuga eum quidem sint
          consectetur velit
        </p>
        <div className="team-cards" data-aos="fade-up">
          <div className="team-card">
            <div className="image-container">
              <img
                src=" https://img.freepik.com/premium-photo/portrait-handsome-ceo-smiling_763111-29195.jpg"
                alt="Employee 1"
              />
              <div className="team-social-icons">
                <i className="fab fa-facebook-f"></i>
                <i className="fab fa-instagram"></i>
                <i className="fab fa-whatsapp"></i>
                <i className="fab fa-linkedin-in"></i>
              </div>
            </div>
            <div className="card-info">
              <h3>Jaswant Lovanshi</h3>
              <p>CEO</p>
            </div>
          </div>
          <div className="team-card">
            <div className="image-container">
              <img
                src="https://img.freepik.com/premium-photo/portrait-happy-young-man-coder_280538-6648.jpg?semt=ais_hybrid&w=740"
                alt="Employee 2"
              />
              <div className="team-social-icons">
                <i className="fab fa-facebook-f"></i>
                <i className="fab fa-instagram"></i>
                <i className="fab fa-whatsapp"></i>
                <i className="fab fa-linkedin-in"></i>
              </div>
            </div>
            <div className="card-info">
              <h3>Tarun Lovanshi</h3>
              <p>Java Developer</p>
            </div>
          </div>
          <div className="team-card">
            <div className="image-container">
              <img
                src="https://as2.ftcdn.net/v2/jpg/06/31/24/31/1000_F_631243124_WKxshFmllxdtqDSAQOegU8i5wGD4YvWv.jpg"
                alt="Employee 3"
              />
              <div className="team-social-icons">
                <i className="fab fa-facebook-f"></i>
                <i className="fab fa-instagram"></i>
                <i className="fab fa-whatsapp"></i>
                <i className="fab fa-linkedin-in"></i>
              </div>
            </div>
            <div className="card-info">
              <h3>Deepika Lovanshi</h3>
              <p>UI/UX Designer </p>
            </div>
          </div>
          <div className="team-card">
            <div className="image-container">
              <img
                src="https://img.freepik.com/premium-photo/focused-programmer-work_1167491-4847.jpg?semt=ais_hybrid&w=740"
                alt="Employee 4"
              />
              <div className="team-social-icons">
                <i className="fab fa-facebook-f"></i>
                <i className="fab fa-instagram"></i>
                <i className="fab fa-whatsapp"></i>
                <i className="fab fa-linkedin-in"></i>
              </div>
            </div>
            <div className="card-info">
              <h3>Pankaj Lovanshi</h3>
              <p>MERN STACK Developer</p>
            </div>
          </div>
        </div>
      </div>

      {/* 3 section */}

      <div className="client" style={{backgroundColor:"white"}}>
        <div className="client-heading" data-aos="fade-up">
          <h1 style={{marginTop:"-35px"}}>CLIENTS</h1>
        </div>
        <p data-aos="fade-up">
          Necessitatibus eius consequatur ex aliquid fuga eum quidem sint
          consectetur velit
        </p>
        <div className="client-grid" data-aos="fade-up">
          {[
            "Google",
            "Microsoft",
            "Amazon",
            "Netflix",
            "Apple",
            "IBM",
            "Adobe",
            "Meta",
          ].map((company, idx) => (
            <div key={idx} className="client-box">
              <span className="client-name">{company}</span>
            </div>
          ))}
        </div>
      </div>
    </>
  );
}
